import {
  Directive,
} from '@angular/core';
import { _getEventTarget } from '@angular/cdk/platform';
import {
  MENU_TRIGGER,
  PARENT_OR_NEW_MENU_STACK_PROVIDER,
} from '@angular/cdk/menu';
import { SharedMenuTriggerDirective } from '@seech/shared-ng';

export type MenuPositionX = 'start' | 'end' | 'center';

@Directive({
  selector: '[sch-menu-trigger-for]',
  exportAs: 'schMenuTriggerFor',
  standalone: true,
  host: {
    class: 'sch-menu-trigger',
  },
  providers: [
    { provide: MENU_TRIGGER, useExisting: MenuTriggerDirective },
    PARENT_OR_NEW_MENU_STACK_PROVIDER,
  ],
})
export class MenuTriggerDirective extends SharedMenuTriggerDirective {}
